var raSearcheEnglishMessages = {
    'ra-search': {
        recent: 'Recent',
    },
};
export default raSearcheEnglishMessages;
